import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Field, reduxForm, reset, formValueSelector } from "redux-form";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";

// constants
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import LocaleStrings from "Languages";

// actions
import {
  addExtraPointsModal,
  addExtraPoints,
  fetchLeaderboardUserList,
  listAllChallenges,
} from "LeaderboardActions";
import {
  fetchUsersCategory,
  sortUserByCategory,
  editDashboardUser,
} from "DashboardUserAction";
import { openPrivateSessionUserModal } from "ContentActions";
import { showError, showSuccess, showWar } from "ReduxErrorBar";

// components
import SessionPrivateUserModal from "../../../../content/components/schedules/session-private-user-modal";

const NO_CHALLENEGE = "no_challenege";
class ExtraPointsModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      btnloading: false,
      loadingUserModalButton: false,
      manageUserUpdated: false,
      usersToAssignPoints: [],
      allow_assignType: false,
    };
  }

  componentDidMount() {
    this.props.listAllChallenges(this.props.session, (res) => {});
  }

  closeModal = () => {
    this.props.reset();
    this.props.addExtraPointsModal({});
    this.setState({
      btnloading: false,
      loadingUserModalButton: false,
      manageUserUpdated: false,
      usersToAssignPoints: [],
      allow_assignType: false,
    });
  };

  onFormSubmit = (values) => {
    const { session, extraPointsModal, allGameChallenges } = this.props,
      { usersToAssignPoints } = this.state;

    this.setState({ btnloading: true });

    // --- Common resource object
    let updateObj = {
      eventid: session.eventid,
      rewardtype: "point",
      points: values.extra_bonus_points,
      isadminbonus: 1,
      isrecurring: 0,
      users: [],
      assigntype: values.point_assign_type,
    };

    // --- Checing if challenges are selcted, then adding resp
    if (values.selected_challenge !== NO_CHALLENEGE) {
      let filtered_challenge = _.filter(
        allGameChallenges.data,
        (challenge) => challenge.id == values.selected_challenge
      );

      updateObj.challengeid = filtered_challenge[0].id;
      updateObj.isrecurring = filtered_challenge[0].isrecurring;
    }

    // --- Selected users
    if (usersToAssignPoints.length) {
      _.map(usersToAssignPoints, (userData) => {
        updateObj.users.push(userData.appuserid);
      });
    }

    console.log(updateObj, extraPointsModal);

    this.props.addExtraPoints(session, updateObj, (res) => {
      console.log("extra res: ", res);
      if (res.success) {
        this.props.fetchLeaderboardUserList(
          session,
          extraPointsModal?.currentPage ?? 0,
          0,
          (fetchRes) => {
            this.setState({ btnloading: false });
            if (res.success) {
              // Toasts
              if (res.case == "1" || res.case == "2" || res.case == "12") {
                // only add or override
                this.props.showSuccess(
                  LocaleStrings.gamification_extrapoints_modal_success_response
                ); // Modal close
                setTimeout(() => {
                  this.closeModal();
                }, 1000);
              } else if (res.case == "10")
                // add done, override error
                this.props.showSuccess(
                  LocaleStrings.gamification_extrapoints_modal_success_add
                );
              else if (res.case == "02")
                // add error, override done
                this.props.showSuccess(
                  LocaleStrings.gamification_extrapoints_modal_success_override
                );
              else if (res.case == "")
                // nothing happened
                this.props.showError(
                  LocaleStrings.gamification_extrapoints_modal_error_response
                );
            }
          }
        );
      }
    });
  };

  openManageUsers = () => {
    this.setState({ loadingUserModalButton: true });

    // Fetching user categories and all admin users first time
    this.props.fetchUsersCategory(this.props.session, (cateRes) => {
      var admins = _.filter(cateRes.data, (obj) => {
        return obj.type === "admin";
      });
      this.props.sortUserByCategory(
        this.props.session,
        admins[0].id,
        1,
        0,
        (callback) => {
          this.props.openPrivateSessionUserModal({
            show: true,
            type: "gamification",
          });
          this.setState({ loadingUserModalButton: false });
        }
      );
    });
  };

  handleAccoicatedUsers = (selectedUsers) => {
    this.setState({
      usersToAssignPoints: selectedUsers,
      manageUserUpdated: true,
    });
  };

  handleChallengeSelect = (e) => {
    const { allGameChallenges, challengeOptions } = this.props;

    // null check for 'No challenge' case
    if (e.target.value !== NO_CHALLENEGE) {
      let _filterChallengeData = _.filter(
        allGameChallenges.data,
        (challenge) => challenge.id == e.target.value
      );

      this.props.autofill("extra_bonus_points", _filterChallengeData[0].points);
      this.setState({ allow_assignType: true });
    } else {
      this.props.autofill("extra_bonus_points", "");
      this.props.autofill("point_assign_type", "add");
      this.setState({ allow_assignType: false });
    }
  };

  render() {
    const {
        extraPointsModal,
        handleSubmit,
        pristine,
        invalid,
        submitting,
        allGameChallenges,
        challengeOptions,
        sessionPrivateUsersModal,
        radioButtonValue,
      } = this.props,
      {
        btnloading,
        manageUserUpdated,
        loadingUserModalButton,
        usersToAssignPoints,
      } = this.state;

    // Selected Users
    let allSelectedUsers = [];

    if (manageUserUpdated) {
      allSelectedUsers = usersToAssignPoints;
    }

    return (
      <>
        <Modal
          className="modal-container"
          show={
            !_.isEmpty(extraPointsModal) && extraPointsModal.show ? true : false
          }
          onHide={this.closeModal}
          animation={true}
          keyboard={false}
          backdrop="static"
          enforceFocus={false}
          size={"lg"}
        >
          <form onSubmit={handleSubmit(this.onFormSubmit)}>
            <Modal.Header>
              <div
                className="import-modal-title"
                style={{ paddingLeft: "15px" }}
              >
                {LocaleStrings.gamification_extrapoints_modal_header}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={this.closeModal}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                  alt="close extra points modal"
                />
              </button>
            </Modal.Header>

            <Modal.Body>
              <div className="row">
                {/* --- Challenge | DD --- */}
                <div className="col-sm-9">
                  <div className="form-group">
                    <Field
                      label={
                        LocaleStrings.gamification_extrapoints_modal_select_challenge
                      }
                      name={"selected_challenge"}
                      component={this.renderSelect}
                      opts={challengeOptions}
                      labelposition={LABEL_POSITION_TOP}
                      onChange={this.handleChallengeSelect}
                    />
                  </div>
                </div>

                {/* --- Points | Input --- */}
                <div className="col-sm-9">
                  <div className="form-group">
                    <Field
                      name="extra_bonus_points"
                      type="number"
                      label={
                        LocaleStrings.gamification_extrapoints_modal_add_bonus_label
                      }
                      placeholder={
                        LocaleStrings.gamification_extrapoints_modal_add_bonus_ph
                      }
                      component={this.renderFieldText}
                      labelposition={LABEL_POSITION_TOP}
                      min={"0"}
                    />
                  </div>
                </div>

                {/* --- How to add points | Radio - Conditional, render if challenege is selected --- */}
                {this.state.allow_assignType ? (
                  <>
                    <div className="col-sm-9 mb-2">
                      <label>
                        {
                          LocaleStrings.gamification_extrapoints_modal_explainatory_note
                        }
                      </label>
                    </div>
                    <div className="col-sm-9">
                      <div className="form-group">
                        <Field
                          label={
                            LocaleStrings.gamification_extrapoints_modal_radio_add_as_bonus
                          }
                          name="point_assign_type"
                          type="radio"
                          value="add"
                          component={this.renderFieldRadio}
                        />
                        <Field
                          label={
                            LocaleStrings.gamification_extrapoints_modal_radio_override
                          }
                          name="point_assign_type"
                          type="radio"
                          value="override"
                          component={this.renderFieldRadio}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}

                {/* --- Choose users to assign points --- */}
                <div className="col-sm-9">
                  {/* <div className={showORhideUsers}> */}
                  <div className="form-group">
                    <Button
                      type="button"
                      className="btn-default"
                      style={{ marginRight: 5 }}
                      disabled={true}
                    >
                      <span className="schedule-user-selected">
                        {allSelectedUsers.length > 0
                          ? `${allSelectedUsers.length} ${LocaleStrings.users_selected}`
                          : `${allSelectedUsers.length} ${LocaleStrings.user_selected}`}
                      </span>
                    </Button>

                    <Button
                      bsStyle=""
                      className="btn btn-custom-blue"
                      onClick={() => this.openManageUsers()}
                      loading={loadingUserModalButton}
                    >
                      {!loadingUserModalButton ? (
                        <i
                          className="fa fa-plus i-custom-m"
                          aria-hidden="true"
                        />
                      ) : (
                        ""
                      )}
                      {LocaleStrings.button_select_users}
                    </Button>
                  </div>
                </div>

                <div className="col-sm-9-">
                  <span className="label-mandatory">
                    {LocaleStrings.note}:{" "}
                  </span>
                  <span>
                    {!this.state.allow_assignType
                      ? LocaleStrings.gamification_extrapoints_modal_desc_add
                      : radioButtonValue === "add"
                      ? LocaleStrings.gamification_extrapoints_modal_desc_challenge_add
                      : LocaleStrings.gamification_extrapoints_modal_desc_challenge_override}
                  </span>
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                bsStyle=""
                className="btn btn-custom-white"
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                bsStyle=""
                className="btn btn-custom-blue ml-10"
                loading={btnloading}
                type="submit"
                disabled={
                  pristine || invalid || submitting || !allSelectedUsers.length
                }
              >
                {LocaleStrings.button_close_and_save}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>

        {sessionPrivateUsersModal.show ? (
          <SessionPrivateUserModal
            updateAccoicatedUsers={this.handleAccoicatedUsers}
            membersData={allSelectedUsers}
            flag={"GAMIFICATION"}
          />
        ) : null}
      </>
    );
  }
}

const selector = formValueSelector("ExtraPointsAddFrom");

const validate = (values, props) => {
  let errors = {};

  if (
    !_.isEmpty(values.extra_bonus_points) &&
    (values.extra_bonus_points < 1 || values.extra_bonus_points == "")
  )
    errors.extra_bonus_points =
      LocaleStrings.gamification_extrapoints_modal_validation_extrapoints;

  if (
    _.isEmpty(values.extra_bonus_points) &&
    values.extra_bonus_points < 1 &&
    _.isEmpty(values.selected_challenge)
  )
    errors.selected_challenge =
      LocaleStrings.gamification_extrapoints_modal_select_challenge_validation;

  return errors;
};

const mapStateToProps = (state) => {
  let challengeOptions = [
    {
      // name: LocaleStrings.gamification_extrapoints_modal_select_challenge_ph,
      name: LocaleStrings.gamification_extrapoints_modal_no_challenge_only_bonus,
      value: NO_CHALLENEGE,
    },
  ];
  if (
    !_.isEmpty(state.allGameChallengesReducer) &&
    state.allGameChallengesReducer.count > -1
  ) {
    _.map(state.allGameChallengesReducer.data, (challenge, index) => {
      challengeOptions.push({
        name: `${challenge.challengename}${
          challenge.challengedesc.length ? " - " + challenge.challengedesc : ""
        }`,
        value: challenge.id,
      });
    });
  }

  let initialValue = {
    extra_bonus_points: "",
    selected_challenge: challengeOptions[0].value,
    point_assign_type: "add",
  };

  return {
    session: state.session,
    extraPointsModal: state.extraPointsModalReducer,
    allGameChallenges: state.allGameChallengesReducer,
    sessionPrivateUsersModal: state.sessionPrivateUsersModal,
    radioButtonValue: selector(state, "point_assign_type"),
    challengeOptions,
    initialValues: initialValue,
  };
};

export default connect(mapStateToProps, {
  addExtraPointsModal,
  addExtraPoints,
  fetchLeaderboardUserList,
  listAllChallenges,
  fetchUsersCategory,
  sortUserByCategory,
  editDashboardUser,
  openPrivateSessionUserModal,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "ExtraPointsAddFrom",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ExtraPointsModal)
);
